import {
  TLang,
  IPageMeta,
  IPageData,
  IHomePage,
  ChooseType,
  IFleetData,
  IFAQResponse,
  ILocationPage,
  IBlogItemType,
  IBlogPageResponse,
} from '@/types'
import { API_ENDPOINT } from '@/constants'
import endpoints from '@/apis/endpoints'

import { generatePath } from './urls'

const get = async <T>(endpoint: string, options?: RequestInit): Promise<T> => {
  try {
    console.log('\x1b[32m%s\x1b[0m', `${API_ENDPOINT}${endpoint}`)
    const response = await fetch(`${API_ENDPOINT}${endpoint}`, {
      ...options,
      next: { revalidate: 24 * 3600 },
    })
    const data = await response.json()
    return data
  } catch (error: any) {
    console.log('\x1b[31m%s\x1b[0m', error.message)
    return error
  }
}

export const getAboutUsPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.aboutUs, { lang }),
    )
    return response.data.page
  } catch (error) {
    return undefined
  }
}

export const getContactUsPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.contactUs, { lang }),
    )
    return response.data.page
  } catch (error) {
    return undefined
  }
}

export const getOneWayRentalsPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.oneWayRentals, { lang }),
    )
    return response.data
  } catch (error) {
    return undefined
  }
}

export const getFAQPage = async (lang: TLang) => {
  try {
    const response = await get<IFAQResponse & { meta: IPageMeta }>(
      generatePath(endpoints.faq, { lang }),
    )
    return response
  } catch (error) {
    return undefined
  }
}

export const getStartPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.welcome, { lang }),
    )
    return response.data.page
  } catch (error) {
    return undefined
  }
}

export const getEditPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.edit, { lang }),
    )
    return response.data.page
  } catch (error) {
    return undefined
  }
}

export const getTermsPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.terms, { lang }),
    )

    return response.data.page
  } catch (error) {
    return undefined
  }
}

export const getBlogPage = async (
  lang: TLang,
  blog = '',
  params = {
    page: '1',
    size: '4',
  },
) => {
  try {
    const flag = !blog
    const response = await get<
      ChooseType<IBlogPageResponse, IBlogItemType, typeof flag>
    >(
      generatePath(
        endpoints.blog,
        { lang, blog },
        // @ts-ignore
        Object.keys(params).reduce(
          // @ts-ignore
          (acc, param) => [...acc, { [param]: params[param] }],
          [],
        ),
      ),
    )

    return response
  } catch (error) {
    return undefined
  }
}

export const getFleetPage = async (lang: TLang) => {
  try {
    const response = await get<IFleetData>(
      generatePath(endpoints.fleet, { lang }),
    )

    return response
  } catch (error) {
    return undefined
  }
}

export const getLocationPage = async (lang: TLang, location: string) => {
  try {
    const response = await get<ILocationPage>(
      generatePath(endpoints.location, { lang, location }),
    )

    return response.data
  } catch (error) {
    return undefined
  }
}

export const getCookiePage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.cookiePolicy, { lang }),
    )
    return response.data
  } catch (error) {
    return undefined
  }
}

export const getPrivacyPage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.privacyPolicy, { lang }),
    )
    return response.data
  } catch (error) {
    return undefined
  }
}

export const getTermsOfUsePage = async (lang: TLang) => {
  try {
    const response = await get<IPageData>(
      generatePath(endpoints.termsOfUse, { lang }),
    )
    return response.data
  } catch (error) {
    return undefined
  }
}

export const getHomePage = async (lang: TLang) => {
  try {
    const response = await get<IHomePage>(
      generatePath(endpoints.home, { lang }),
    )
    return response.data
  } catch (error) {
    return undefined
  }
}
